module.exports = __webpack_public_path__ + "static/tabliczka_thumb-6a592c696aca685758e8b34b8696a27f.jpg";